import { render, staticRenderFns } from "./BlockListInfogram.vue?vue&type=template&id=419deaa4&"
import script from "./BlockListInfogram.vue?vue&type=script&lang=js&"
export * from "./BlockListInfogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports